module.exports = __webpack_public_path__ + "img/Rattipong.ef948f42.jpg";